import request from "@/utils/request";
import qs from "qs";

// 查询秒杀活动列表
export function getActivityList(params) {
  return request({
    url: "/seckill/getActivityList",
    method: "get",
    params
  });
}

// 编辑秒杀活动
export function editActivity(params) {
  return request.post("/seckill/editActivity", qs.stringify(params));
}
// 删除秒杀活动
export function deleteActivity(params) {
  return request.post("/seckill/deleteActivity", qs.stringify(params));
}

// 查询活动商品列表
export function getActivityGoods(params) {
  return request({
    url: "/seckill/getActivityGoods",
    method: "get",
    params
  });
}
// 编辑活动商品
export function editActivityGoods(params) {
  return request.post("/seckill/editActivityGoods", qs.stringify(params));
}
// 删除活动商品
export function deleteActivityGoods(params) {
  return request.post("/seckill/deleteActivityGoods", qs.stringify(params));
}
